<template>
  <div>
    <div v-if="!editing">
      <span class="text-primary">{{
        profile.description ? profile.description : "Keine Beschreibung"
      }}</span>
    </div>
    <div v-else>
      <span v-if="isDescriptionChecking">
        Deine Beschreibung wird momentan überprüft.
      </span>
      <textarea
        v-model="description_update"
        class="form-control"
        maxlength="300"
      >
      </textarea>
      {{ description_update.length }} / 300
    </div>
    <div v-if="canUpdate" class="btn-group mt-3">
      <button v-if="editing" @click="save()" class="btn btn-primary">
        <i class="fas fa-save"></i> Speichern
      </button>
      <button @click="editing = !editing" class="btn btn-primary">
        <i class="fas" :class="[editing ? 'fa-times' : 'fa-edit']"></i>
        {{ editing ? "Abbrechen" : "Beschreibung bearbeiten" }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.profile.review) {
      this.description_update = this.profile.review.payload || "";
    } else {
      this.description_update = this.profile.description || "";
    }
  },
  data() {
    return {
      editing: false,
      description_update: ""
    };
  },
  props: ["profile", "canUpdate"],
  methods: {
    save() {
      this.$store
        .dispatch("customerProfile/update", {
          url: this.profile.update_url,
          data: { description_update: this.description_update }
        })
        .then(() => {
          this.$notify({
            title: "Die Beschreibung wird jetzt geprüft",
            type: "success",
            group: "errors"
          });
        })
        .then(() => (this.profile.description_update = this.description_update))
        .finally(() => (this.editing = false));
    }
  },
  computed: {
    isDescriptionChecking() {
      return this.profile.description !== this.profile.description_update;
    }
  }
};
</script>

<style></style>
